// DP
export const DP_SEARCH_FORM = 'dp-load-search-form';
export const DP_SEARCH_FORM_DESTINATION_CLICK = 'dp-search-destination';
export const DP_SEARCH_FORM_DEPARTURE_CLICK = 'dp-search-departure';
export const DP_SEARCH_FORM_DESTINATION_NO_MATCHES = 'dp-search-destination-no-match';
export const DP_SEARCH_FORM_DEPARTURE_NO_MATCHES = 'dp-search-departure-no-match';

// HSA
export const HSA_SEARCH_FORM = 'hotel-standalone-search-form';
export const HSA_SEARCH_CLICK = 'hotel-standalone-search';
export const HSA_SEARCH_FORM_DESTINATION_CLICK = 'hotel-standalone-search-destination';
export const HSA_SEARCH_FORM_DESTINATION_ERROR = 'hotel-standalone-search-destination_error';
export const HSA_SEARCH_FORM_DATES_CLICK = 'hotel-standalone-search-dates';
export const HSA_SEARCH_FORM_DATES_ERROR = 'hotel-standalone-search-dates_error';
export const HSA_SEARCH_FORM_ROOMS_CLICK = 'hotel-standalone-search-rooms';
export const HSA_SEARCH_FORM_ROOMS_NO_MATCHES = 'hotel-standalone-search-destination-no-matches';
export const HSA_SEARCH_FORM_DESTINATION_LOADING_RESULTS = 'hotel-standalone-search-destination-loading-results';

export const HSA_SEARCH_FORM_TAB_DESKTOP_CLICK = 'hotel-standalone-search-form-desktop-tab_click';

export const HSA_SEARCH_FORM_POPULAR_DESTINATION_CLICK = 'hotel-standalone-search-popular-destination_click';

// PixelTracking component display events
export const HOME_ROOT = 'home';
export const HOME_FLIGHTS = 'home_flights';
export const HOME_DP = 'home_dp';
export const HOME_HOTELS_ORGANIC = 'home_hotels_organic';
export const HOME_HOTELS_SEARCH_EXTENSION = 'home_hotels_search_extension';

// SearchExtension
export const SEARCH_EXTENSION_HOTEL_HOME = 'hotels-home_search-extension';

// ErrorBoundary
export const ERROR_BOUNDARY_SHOWN = 'error-boundary';
